import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/Header/base/HeaderBar.tsx
function n({ variant: n, logo: r, search: i, actions: a, below: o, ref: s }) {
	return n === "desktop" ? /* @__PURE__ */ t("div", {
		className: "relative flex w-full flex-col items-center",
		ref: s,
		children: [/* @__PURE__ */ t("div", {
			className: "flex w-full items-center justify-between pb-3",
			children: [
				/* @__PURE__ */ e("div", { className: "hidden shrink basis-1/3 lg:block" }),
				r,
				/* @__PURE__ */ t("div", {
					className: "flex min-h-14 max-w-1/3 grow items-center justify-end",
					children: [i, a]
				})
			]
		}), o]
	}) : /* @__PURE__ */ t("div", {
		className: "w-full",
		ref: s,
		children: [/* @__PURE__ */ t("div", {
			className: "relative z-10 flex min-h-14 flex-wrap items-center justify-between gap-2",
			children: [
				r,
				i ? /* @__PURE__ */ e("div", {
					className: "relative ml-2 hidden max-w-[30rem] grow min-[834px]:block",
					children: i
				}) : null,
				/* @__PURE__ */ e("div", {
					className: "flex items-center gap-1 sm:gap-4",
					children: a
				})
			]
		}), o]
	});
}
//#endregion
export { n as HeaderBar };
